import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import Option from '../select/option'
import Select from '../select/select'
import { availableSectionsPropType } from './props/available-sections-prop-type'

import styles from './tag-section-editor.module.css'

const propTypes = {
    availableSections: availableSectionsPropType.isRequired,
    className: PropTypes.string,
    onChange: PropTypes.func,
    selectedIndex: PropTypes.number
}

const defaultProps = {
    onChange: () => {},
    selectedIndex: 0
}

/**
 * This widget is part of <TagSectionEditor /> - see the docs there. It is not exposed to other outside use
 * Also see props.js for more info on the received propTypes
 */
function SectionsDropdown(props) {
    const { availableSections, className, onChange, selectedIndex } = props
    const onSelect = event => {
        onChange(availableSections[event.target.selectedIndices[0]].id)
    }

    return (
        <Select
            className={cx(styles['dropdown'], className)}
            onChange={onSelect}
            value={availableSections[selectedIndex].id}
        >
            {availableSections.map((item, index) => (
                <Option key={index} value={item.id}>
                    {item.name}
                </Option>
            ))}
        </Select>
    )
}

SectionsDropdown.propTypes = propTypes
SectionsDropdown.defaultProps = defaultProps

export default SectionsDropdown
